import type { VocabWord } from 'modules/vocabulary';

export type StatusFilter = 'all' | 'new' | 'learned';
export type SourceFilter = 'all' | 'IELTS' | 'SAT';

export interface WordFilter {
  query: string;
  status: StatusFilter;
  source: SourceFilter;
  /** Interface language: which translation the search reads. */
  language: string;
}

const translationOf = (word: VocabWord, language: string): string =>
  word.definition ? (language.startsWith('ru') ? word.definition.ru : word.definition.uz) ?? '' : '';

/** Words that match the search text (word, translation, meaning), the status chip and the exam chip. */
export function filterWords(words: readonly VocabWord[], { query, status, source, language }: WordFilter): VocabWord[] {
  const needle = query.trim().toLowerCase();
  return words.filter((word) => {
    if (status === 'learned' && !word.learned) return false;
    if (status === 'new' && word.learned) return false;
    if (source !== 'all' && word.source?.standard !== source) return false;
    if (!needle) return true;
    return [word.word, translationOf(word, language), word.definition?.meaning ?? ''].some((text) => text.toLowerCase().includes(needle));
  });
}

/** How many words are learned, for the header line and the chip count. */
export const learnedCount = (words: readonly VocabWord[]): number => words.filter((word) => word.learned).length;
